import { render, staticRenderFns } from "./BulkCommissionModal.vue?vue&type=template&id=12df502f&scoped=true&"
import script from "./BulkCommissionModal.vue?vue&type=script&lang=js&"
export * from "./BulkCommissionModal.vue?vue&type=script&lang=js&"
import style0 from "./BulkCommissionModal.vue?vue&type=style&index=0&id=12df502f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12df502f",
  null
  
)

export default component.exports